
import { Component, Prop, Vue } from "vue-property-decorator";
import { TimeUtil } from "@/helpers/TimeUtil";
import { warrantyDisplayText, warrantyStatusColor } from "@/helpers/data";

@Component
export default class InstallationItemWarrantyIndicator extends Vue {
  @Prop({ required: true }) item!: Record<string, any>;

  get hasWarrantyInfo() {
    return !!(this.item && this.item.warranty && this.item.installation_date);
  }

  // TODO: Remove it if we won't use it
  // get warrantyText() {
  //   return warrantyDisplayText(this.item.warranty, this.item.warranty_option);
  // }

  get statusColor() {
    return warrantyStatusColor(this.item.is_within_warranty);
  }

  get expireText() {
    return this.item.warranty_expiry_date ? TimeUtil.formattedDate(this.item.warranty_expiry_date) : '';
  }

  get chipMsg() {
    if (!this.expireText) return '';

    return this.item.is_within_warranty === false ? `${this.$t("expired_at")}: ${this.expireText}` : `${this.$t("expires_at")}: ${this.expireText}`;
  }
}
